const PROVIDED_SERVICE_FLOW = "provided service";

export const isProvidedServiceFlow = (
  deliveryFlow?: string | null
): boolean => {
  if (!deliveryFlow) {
    return false;
  }

  const normalizedFlows = deliveryFlow
    .split(",")
    .map((flow) => flow.trim().toLowerCase())
    .filter(Boolean);

  return (
    normalizedFlows.length === 1 && normalizedFlows[0] === PROVIDED_SERVICE_FLOW
  );
};

export const isProvidedServiceNotification = (notification: {
  deliveryFlow?: string | null;
  [key: string]: unknown;
}): boolean => isProvidedServiceFlow(notification.deliveryFlow);
